import React from 'react';

const RequestSteps: React.FC = () => {
  return (
    <div className="RequestSteps" aria-label="Free trial steps">
      <div className="RequestSteps__item">
        <span className="RequestSteps__step">Step 1:</span> Complete the form
      </div>

      <div className="RequestSteps__item">
        <span className="RequestSteps__step">Step 2:</span> Meet with our team
      </div>

      <div className="RequestSteps__item">
        <span className="RequestSteps__step">Step 3:</span> Experience IPO Intelligence
      </div>
    </div>
  );
};

export default RequestSteps;
